import React, { useState, useEffect } from "react";
import "./editnotify.scss";
import Sidebar from "../Sidebar";
import Header from "../../component/loaderComponent/Header/Header";
import { Image_Url } from "../../ImageUrl/ImageUrl";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { decode } from "base-64";
import { useParams } from "react-router-dom";
import useMobileView from "../../constants/useMobileView";
import { HiMenu, HiX } from "react-icons/hi";

import {
  notificationdetailByIdAction,
  updateNotificationAction,
} from "../../actions/notificationAction";
import { notify } from '../../services/notification';
import {
  stateListAction,
  districtListAction,
  usergroupListAction,
  RedirectionPageListAction
} from "../../actions/notificationAction";
import Loader from "../../component/loaderComponent/loaderComponent/Loader";

function TrainerNotification() {
  const [cities, setcities] = useState([]);
  const [district_Id, setDistrict_Id] = useState([]);
  const {  isSidebarOpen, toggleSidebar } = useMobileView();

  const [grouplist, setGrouplist] = useState([]);
  const [newcity, setNewcity] = useState("");
  const [statelist, setStatelist] = useState([]);
  const [district, setDistrict] = useState([]);
  const [count, setCount] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [states, setDataStates] = useState({
    state: "",
    region: "",
    region_type: "",
    title: "",
    minimum_redemption_amount:"",
    body: "",
    starting_date: "",
    starting_time: "",
    duration: "",
    group: "",
    redirection_page:""
  });
  const [textCount, setTextCount] = useState(0);
  const [textCounts, setTextCounts] = useState(0);
  const { id } = useParams();
  const decodeid = decode(id);
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedTime, setSelectedTime] = useState("");
  const [currentDateTime, setCurrentDateTime] = useState(new Date());
  const [redirectionPagelist, setRedirectionPagelist] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    notificationDetailData();
    stateListData();
    GetRedirectionPageListData();
    getgroupListData();
    districtListData(states.state);
  }, []);

  async function getgroupListData() {
    setIsLoading(true);
    var response = await dispatch(usergroupListAction());
    if (response.status === 200) {
      setIsLoading(false);
      const dataArray = Object.entries(response?.data?.data)?.map(([key, value]) => ({
        group_key: key,
        group_value: value
      }));
      setGrouplist(dataArray);
    }

  }
  async function GetRedirectionPageListData() {
    setIsLoading(true);
    var response = await dispatch(RedirectionPageListAction());
    if (response.status === 200) {
      setIsLoading(false);
      setRedirectionPagelist(response.data.data);
    }

  }

  function updateChars(e) {
    const text = document.getElementById("text").value;
    setTextCount(text.length);
  }
  function updateCharsters(e) {
    const text = document.getElementById("text2").value;
    setTextCounts(text.length);
  }

  async function notificationDetailData() {
    setIsLoading(true);
    var response = await dispatch(notificationdetailByIdAction(decodeid));
    if (response == 200 || response != null) {
      setSelectedDate(response.data.data[0].starting_date);
      setSelectedTime(response.data.data[0].starting_time);
      setcities(response.data.data[0].districts);
      setDistrict_Id(response.data.data[0].district_id);
      districtListData(response.data.data[0]?.state_id);
      setDataStates({
        ...states,
        state: response.data.data[0].state_id,
        region: response.data.data[0].region,
        region_type: response.data.data[0].region_type,
        title: response.data.data[0].title,
        minimum_redemption_amount: response.data.data[0].minimum_redemption_amount,
        body: response.data.data[0].body,
        starting_date: response.data.data[0].starting_date,
        starting_time: response.data.data[0].starting_time,
        duration: response.data.data[0].duration,
        group: response.data.data[0].user_group,
        redirection_page: response.data.data[0].redirection_page_id
      });
      setIsLoading(false);
    }
  }

  async function updateNotification(e) {
    e.preventDefault();
    setIsLoading(true);
    let apiReq = {
      district_ids: district_Id.map((data) => data),
      title: states.title,
      minimum_redemption_amount: states.minimum_redemption_amount,
      body: states.body,
      starting_date: selectedDate,
      starting_time: selectedTime,
      duration: states.duration,
      user_group: states.group,
      redirection_page: states.redirection_page,
      state_id: states.state, //Include the state ID in the request payload
    };
    if (!apiReq.user_group) {
      delete apiReq.user_group;
    }
    if (!apiReq.state_id) {
      delete apiReq.state_id;
    }
    if (states.minimum_redemption_amount === "") {
      delete apiReq.minimum_redemption_amount;
    }
    let response = await dispatch(updateNotificationAction(apiReq, decodeid));
    if (response == 200 || response != null) {
      setIsLoading(false);
      notify.success("Notification has been updated successfully.");
      navigate("/notification");
      window.scroll(0, 0);
    }
    if(response === undefined){
      setIsLoading(false);
    }
  }

  const handleChange = (evt) => {
    const value = evt.target.value;
    setDataStates({
      ...states,
      [evt.target.name]: value.replace(/^ +/gm, ""),
    });
    updateChars();
    updateCharsters();
  };

  // Function to handle adding a new city
  const addcity = () => {
    if (newcity.trim() !== "" && cities.length < 5) {
      const { id, district } = JSON.parse(newcity);
  
      // Check if the district with the same ID already exists
      const districtExists = district_Id.includes(id);
  
      if (!districtExists) {
        setcities([...cities, district]);
        setDistrict_Id([...district_Id, id]);
        setNewcity("");
      } else {
        notify.error("City already added");
      }
    }
  };
  const removecity = (index) => {
    const updatedcities = [...cities];
    updatedcities.splice(index, 1);
    const updatedDistrict_Id = [...district_Id];
    updatedDistrict_Id.splice(index, 1);
    setcities(updatedcities);
    setDistrict_Id(updatedDistrict_Id);
  };

  const handleChangeState = (evt) => {
    const state_id = evt.target.value;
    setDataStates({
      ...states,
      state: state_id,
    });
    setcities([]);
    setDistrict_Id([]);
    districtListData(state_id); // Load districts based on selected state
  };

  // Function calling For State List

  async function stateListData() {
    setIsLoading(true);
    var response = await dispatch(stateListAction());
    if (response == 200 || response != null) {
      setIsLoading(false);
      if (response.data.count % 10 == 0) {
        setCount(Math.floor(response.data.count / 10));
      } else {
        setCount(Math.floor(response.data.count / 10 + 1));
      }
      setStatelist(response?.data?.results?.data);
      // setStatelist(response.data.data);
      if (states?.state !== "") {
        districtListData(states?.state);
      }
    }
  }
  // Function calling for District List based On state

  async function districtListData(state_id) {
    setIsLoading(true);
    var response = await dispatch(districtListAction(state_id));
    if (response == 200 || response != null) {
      setIsLoading(false);
      if (response.data.count % 10 == 0) {
        setCount(Math.floor(response.data.count / 10));
      } else {
        setCount(Math.floor(response.data.count / 10 + 1));
      }
      // setDistrict(response.data.results.data);
      setDistrict(response.data.data);
    }
  }

  const handleDateChange = (event) => {
    setSelectedTime("");
    const { value } = event.target;
    setSelectedDate(value);
    if (value === getCurrentDate()) {
      setCurrentDateTime(new Date());
    } else {
      setCurrentDateTime(null);
    }
  };

  const handleTimeChange = (event) => {
    const { value } = event.target;
    if (selectedDate === getCurrentDate() && value < getCurrentTime()) {
      setSelectedTime(getCurrentTime());
    } else {
      setSelectedTime(value);
    }
  };

  const getCurrentDate = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const getCurrentTime = () => {
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    return `${hours}:${minutes}`;
  };

  return (
    <div className="trainercontainer">
      <div className="trainercontainerright">
        <Header title="Edit Notification" />
        <div class="container_s">
          {isLoading ? (
            <Loader />
          ) : (
            <form>
              <div className="grid">
                <span className="span-edit-notification">State</span>
                <select
                  name="state"
                  value={states.state}
                  onChange={handleChangeState}
                >
                  <option value="0">Select State</option>
                  {statelist?.map((item) => (
                    <option value={item.id}>{item?.state}</option>
                  ))}
                </select>
              </div>
              <div className="grid">
            <span className="span-edit-notification">
                  City/District
                </span>
                <select
                  value={newcity}
                  onChange={(e) => setNewcity(e.target.value)}
                  disabled={cities.length === 3}
                >
                  <option value="">Select City/District</option>
                  {district.map((list) => (
                    <option key={list.id} value={JSON.stringify(list)}>
                      {list.district}
                    </option>
                  ))}
                </select>
                <img src={Image_Url.PLUS} height="40%" onClick={addcity}></img>
              </div>
              {cities.map((city, index) => (
                <div className="grid" key={city.id}>
                  <p></p>
                  <select value={city} readonly disabled={cities.length > 0}>
                    <option value={city.id}>
                      {city.district
                        ? city.district.replace(/['"]+/g, "")
                        : city.replace(/['"]+/g, "")}
                    </option>
                  </select>
                  <img
                    src={Image_Url.MINUS}
                    onClick={() => removecity(index)}
                  />
                </div>
              ))}
                <div className="grid">
              <span className="span-edit-notification">Select Group</span>
              <select
                name="group"
                value={states.group}
                onChange={handleChange}
              >
                <option value="">Select Group</option>
                {grouplist.map((item)=>
                <option value={item.group_key}>{item.group_value}</option>
                )}
              </select>
            </div>
            {
              states.group !== "sufficient_balance_for_redemption" && states.group !== "low_balance_in_wallet" ?
             "" : 
              <div className="grid">
                  <label className="label-edit-notification">Redemption Amount</label>
                  <textarea
                    className="heading"
                    placeholder="Redemption Amount"
                    name="minimum_redemption_amount"
                    value={states.minimum_redemption_amount}
                    onChange={handleChange}
                  ></textarea>
                </div>
              }
              <div class="grid">
                <label className="edit-notify-label">Heading</label>
                <textarea
                  class="heading"
                  name="title"
                  value={states.title}
                  onChange={handleChange}
                  maxLength={100}
                  id="text2"
                ></textarea>
                <p className="notyfy-headings montserrat-font">
                  {textCounts}/100
                </p>
              </div>
              <div class="grid">
                <label className="edit-notify-label">Description</label>
                <textarea
                  class="description"
                  name="body"
                  value={states.body}
                  onChange={handleChange}
                  id="text"
                  maxLength={300}
                ></textarea>
                <p className="notyfy-descriptions montserrat-font">
                  {textCount}/300
                </p>
              </div>
              <div class="grid">
                <label className="edit-notify-label">Select Redirection Page</label>
                <select
                name="redirection_page"
                value={states.redirection_page}
                onChange={handleChange}
                >
                <option value="">Select Redirection Page</option>
                {redirectionPagelist.map((data)=>
                <option key={data.id} value={data.id}>{data.page}</option>
                )}
                </select>
              </div>
              <div class="grid date">
                <label className="edit-notify-label">Send On Date</label>
                <input
                  type="date"
                  id="date"
                  placeholder="dd/mm/yy"
                  name="starting_date"
                  value={selectedDate}
                  onChange={handleDateChange}
                  min={getCurrentDate()}
                />
              </div>
              <div class="grid">
                <label className="edit-notify-label">Send at Time</label>
                <input
                  type="time"
                  name="starting_time"
                  value={selectedTime}
                  onChange={handleTimeChange}
                  disabled={!selectedDate}
                />
              </div>
              <div class="grid">
                <label className="edit-notify-label">Duration</label>
                <select
                  name="duration"
                  value={states.duration}
                  onChange={handleChange}
                >
                  <option>Select Duration</option>
                  <option value="1 00:00:00">1 day</option>
                  <option value="2 00:00:00">2 days</option>
                  <option value="3 00:00:00">3 days</option>
                  <option value="4 00:00:00">4 days</option>
                  <option value="5 00:00:00">5 days</option>
                  <option value="6 00:00:00">6 days</option>
                  <option value="7 00:00:00">7 days</option>
                  <option value="8 00:00:00">8 days</option>
                  <option value="9 00:00:00">9 days</option>
                  <option value="10 00:00:00">10 days</option>
                  <option value="11 00:00:00">11 days</option>
                  <option value="12 00:00:00">12 days</option>
                  <option value="13 00:00:00">13 days</option>
                  <option value="14 00:00:00">14 days</option>
                  <option value="15 00:00:00">15 days</option>
                </select>
              </div>

              <div class="btn-notify">
                <button
                  onClick={() => {
                    navigate("/notification");
                  }}
                  className="notify-active"
                >
                  Close
                </button>
                <button
                  onClick={updateNotification}
                  className="Edit-notyfy-Button"
                  disabled={
                    states.newcity === "" ||
                    states.title === "" ||
                    states.body === "" ||
                    states.starting_date === "" ||
                    states.starting_time === "" ||
                    states.duration === "" ||
                    states.redirection_page === ""
                  }
                >
                  Update
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
export default TrainerNotification;
